module.exports = __webpack_public_path__ + "img/logo-old.a6ff7506.svg";